import React from 'react';
import createSVG from './createSVG';

const FilterIcon = ({style}) => (
  <path style={style} d="M24.49 1.125H12.74m1.762 23.5h-1.757M24.5 1.297l-9.996 9.998m0 0v13.167M1.01 1.125H12.76m-1.762 23.5h1.757M1 1.297l9.996 9.998m0 0v13.167" stroke="#fff" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(FilterIcon);
